import { render } from "./LoadingBar.vue?vue&type=template&id=67ccd932"
const script = {}

import "./LoadingBar.vue?vue&type=style&index=0&id=67ccd932&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress});
